import { Outlet } from 'react-router-dom';
import { Mui } from '@onedesign/ui';
import logo from '/static/images/logo.svg';
import { LanguageSwitcher } from 'components/ChangeLanguage';
import NavbarQR from 'layouts/dashboard/navbar/NavbarQR';
import { t } from 'utils/i18n';
import {
  StyledChangeLanguageBox,
  StyledLogin,
  StyledLoginBox,
  StyledLoginIntro,
  StyledLoginIntroLogo,
  StyledLoginIntroLogoContainer,
} from './Auth.style';

const { Typography } = Mui;

const AuthLayout = () => {
  return (
    <>
      <StyledLogin>
        <StyledChangeLanguageBox>
          <LanguageSwitcher />
        </StyledChangeLanguageBox>
        <StyledLoginBox>
          <StyledLoginIntro>
            <StyledLoginIntroLogoContainer>
              <StyledLoginIntroLogo src={logo} />
            </StyledLoginIntroLogoContainer>
            <Typography
              sx={theme => ({
                color: theme.palette.grey[600],
                fontSize: '20px',
                fontWeight: 500,
                marginTop: '8px',
              })}
            >
              {t('login.teacherManagementSystem', '教師管理系統')}
            </Typography>
          </StyledLoginIntro>
          <Outlet />
        </StyledLoginBox>
      </StyledLogin>
      <NavbarQR mobilePosition="fixed" />
    </>
  );
};

export default AuthLayout;
